<template>
    <div v-if="canShow('体质调理方案') && info && module && module.data && module.data.length > 0 && hasAdjustmentItems">
        <div class="tips"></div>
        <div class="sick-box">
            <div class="risk">体质调理方案</div>
        </div>
        <div class="assessment" v-for="(items, index) in module.data" :key="index">
            <div class="sick-dosc" v-if="isAdjustmentItem(items)">
                <div class="sick-title-status">{{ items.module_name }}</div>
                <div class="flex sutra-top flex-w">
                    <div v-for="(item1, index1) in items.description_list" :key="index1">
                        <div class="sutra-title" :class="{ active: item1.active }" @click="() => change({ index: index, index1: index1 })">
                            {{ formatSyndrome(item1.syndrome_name) }}<span v-if="info.report_type == 1 && !isStep19">({{ item1.index == 0 ? '主' : '兼' }})</span>
                        </div>
                    </div>
                </div>
                <div v-for="(item2, index2) in items.description_list" :key="index2">
                    <div v-if="item2.list && item2.active && needsLengthCheck(item2.list,items.module_name)" class="flex sutra-top flex-w">
                        <div v-for="(item3, index3) in item2.list" :key="index3">
                            <div class="sutra-title" v-if="item3.module_value[0].value" :class="{ active: item3.active }" @click="() => changeTwo({ index: index, index1: index2, index2: index3 })">{{ item3.module_value[0].value }}</div>
                        </div>
                    </div>
                </div>
                <div class="sick-inner">
                    <div v-for="(item2, index3) in items.description_list" :key="'desc-' + index3">
                        <div v-if="item2.list && item2.active">
                            <div v-for="(item3, index3b) in item2.list" :key="index3b">
                                <div v-if="item3.active">
                                    <div v-if="items.is_need_audio == 1" class="sick-audio">
                                        <div v-for="(audio, index6) in item3.audio" :key="index6">
                                            <audio :src="audio" controls="controls">您的浏览器不支持html5的audio标签</audio>
                                        </div>
                                    </div>
                                    <div v-for="(item4, index4) in item3.module_value" :key="index4">
                                        <div v-if="index4 > 0">
                                            <div class="sick-title">{{ item4.title }}</div>
                                            <div class="sick-text" v-html="zhFilter(item2.syndrome_name, item4.value, info.sex, items.module_name)"></div>
                                        </div>
                                    </div>
                                    <div v-if="items.is_need_image == 1" class="sick-img">
                                        <div v-for="(img, index5) in item3.images" :key="index5">
                                            <img :src="img" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { moduleMixin, isFlowStep19, isFlowStep20, formatModuleSyndromeName, zhFilter } from '../helpers';

export default {
    name: 'ReportAdjustment',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info', 'module']),
        isStep19() { return isFlowStep19(this.info)||isFlowStep20(this.info); },
        hasAdjustmentItems() {
            if (!this.module || !this.module.data) return false;
            return this.module.data.some((items) => this.isAdjustmentItem(items));
        }
    },
    methods: {
        zhFilter,
        formatSyndrome(name) { return formatModuleSyndromeName(name, this.info); },
        needsLengthCheck(item2,module_name) {
            if(item2.length>1){
                return true;
            }else{
                const checkValues = ['体质特征', '情志调摄', '饮食调养', '起居调摄', '运动保健', '穴位保健'];
                if (checkValues.includes(module_name)) {
                    return false;
                }else{
                    return true;
                }
            }
        },
        isAdjustmentItem(items) {
            if (!items || !items.module_name) return false;
            // module.data 中除"体质特征/发病倾向"外的子项都属于体质调理方案
            // 顶层可见性已由外层 canShow('体质调理方案') 控制，这里无需再逐项过滤
            return items.module_name !== '体质特征' && items.module_name !== '发病倾向';
        },
        ...mapMutations('report', ['change', 'changeTwo'])
    }
};
</script>
<style lang="scss" scoped>
@import './Adjustment.scss';
</style>
